/* eslint-disable */
import React from 'react'

export function ServiceCard({ icon:IconComponent, title, text }) {
    return (
        <div className="w-[100%] flex flex-col items-start gap-[20px]">
            <div className="p-[25px] bg-[#0068B5] rounded-[10px]">
                {IconComponent && <IconComponent />}
            </div>
            <div className="w-[100%] flex flex-col items-start gap-[14px]">
                <span className="text-black dark:text-white font-[700] text-[21px]">{title}</span>
                <span className="text-black/50 dark:text-white text-[18px]">{text}</span>
            </div>
        </div>
    )
}
